import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../use-auth';

interface DashboardGateProps {
  children: ReactNode;
}

export function DashboardGate({ children }: DashboardGateProps) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated) {
    return <Navigate to={`/auth/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  const tier = auth.profile?.tier;
  if (tier !== 'admin') {
    return (
      <main className="dashboard-shell" style={{ padding: '2rem', maxWidth: 640, margin: '0 auto' }}>
        <h1>Bạn không có quyền truy cập trang này</h1>
        <p>Trang này dành cho quản trị viên Asklaw. Nếu bạn nghĩ đây là lỗi, vui lòng liên hệ founder.</p>
        <a href="/">Quay về trang chủ</a>
      </main>
    );
  }

  return <>{children}</>;
}
